<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="col-md-12 col-lg-10 d-flex align-items-center">
        <div class="mb-3 me-3 col-auto d-flex align-items-center">
          <h2>Karta ewidencji czasu pracy: {{ userName }} - {{ this.selectedYear }}</h2>
        </div>

        <div class="mb-3 col-auto d-flex align-items-center">
          <Link :href="route('kadry.show.user', this.userId)" class="btn btn-outline-primary">
          <i class="bi bi-arrow-counterclockwise"></i>&nbsp;Powrót
          </Link>
        </div>

        <div class="mb-3 col-auto d-flex align-items-center ms-auto">
          <select v-model="selectedYear" class="form-select form-xs mb-2 ms-2" style="width: 140px;" @change="loadData">
            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
      </div>

      <div class="half-year mb-5">
        <div class="col-auto d-flex align-items-center">
          <h4>Pierwsze półrocze (Styczeń - Czerwiec)</h4>



          <a :href="route('kadry.karta_ewidencji.pdf', { userId: this.userId, year: this.selectedYear, half: 1 })"
            rel="noopener noreferrer" target="_blank" class="btn btn-info btn-sm equal-width-btn me-2 ms-2">
            <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz wypełnioną
          </a>
          <a :href="route('kadry.pusta.karta_ewidencji.pdf', { userId: this.userId, year: this.selectedYear, half: 1 })"
            rel="noopener noreferrer" target="_blank" class="btn btn-outline-info btn-sm equal-width-btn me-2 ms-2">
            <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz pustą
          </a>
        </div>
        <div class="table-responsive w-100 mb-3">
          <table class="table table-bordered table-hover text-center">
            <thead>
              <tr>
                <th class="bg-gray-100"></th>
                <th class="bg-gray-100" v-for="day in 31" :key="'H1-head-' + day">{{ day }}</th>
                <th class="bg-gray-100">R</th>
                <th class="bg-gray-100">N</th>
                <th class="bg-gray-100">GN</th>
                <th class="bg-gray-100">DW</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="month in 6" :key="'H1-' + month">
                <tr>
                  <td class="bg-gray-100 text-start"><strong>{{ monthName(month) }}</strong></td>
                  <td v-for="day in 31" :key="'H1-hours-row-' + month + '-' + day" :class="[
                    'p-1',
                    day > getDaysInMonth(month).length
                      ? 'bg-white text-dark'
                      : (isHoliday(getDateString(day, month)) || isWeekend(month, day))
                        ? 'bg-Lightblue text-white'
                        : 'bg-white'
                  ]">
                    <span v-if="day > getDaysInMonth(month).length" class="fw-bold">X</span>
                    <span v-else-if="!shouldRenderCell(this.selectedYear, month, day)"></span>
                    <span v-else>
                      <span v-if="isHoliday(getDateString(day, month)) || isWeekend(month, day)"></span>
                      <span v-else :class="getCellClass(day, month, 'days')">
                        {{ getCellValue(day, month, 'days') }}
                      </span>
                    </span>
                  </td>
                  <td class="bg-gray-100"><strong>{{ getWorkingHours(month) }}</strong></td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                </tr>

                <tr>
                  <td class="bg-gray-100 text-start"><strong>godz.</strong></td>
                  <td v-for="day in 31" :key="'H1-hours-row-' + month + '-' + day" :class="[
                    'p-1',
                    day > getDaysInMonth(month).length
                      ? 'bg-white text-dark'
                      : (isHoliday(getDateString(day, month)) || isWeekend(month, day))
                        ? 'bg-Lightblue text-white'
                        : 'bg-white'
                  ]">
                    <span v-if="day > getDaysInMonth(month).length" class="fw-bold">X</span>
                    <span v-else-if="!shouldRenderCell(this.selectedYear, month, day)"></span>
                    <span v-else>
                      <span v-if="isHoliday(getDateString(day, month)) || isWeekend(month, day)"></span>
                      <span v-else :class="getCellClass(day, month, 'hours')">
                        {{ getCellValue(day, month, 'hours') }}
                      </span>
                    </span>
                  </td>

                  <td class="bg-gray-100"><span v-if="CzyPodsumowanie(this.selectedYear, month)"><strong>{{
                        getTotalHoursForMonth(month) }}</strong></span></td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>



      <div v-if="currentMonth > 6 || currentYear > this.selectedYear" class="half-year mb-5">
        <div class="col-auto d-flex align-items-center">
          <h4>Drugie półrocze (Lipiec - Grudzień)</h4>
          <a :href="route('kadry.karta_ewidencji.pdf', { userId: this.userId, year: this.selectedYear, half: 2 })"
            rel="noopener noreferrer" target="_blank" class="btn btn-info btn-sm equal-width-btn me-2 ms-2">
            <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz wypełnioną
          </a>
          <a :href="route('kadry.pusta.karta_ewidencji.pdf', { userId: this.userId, year: this.selectedYear, half: 2 })"
            rel="noopener noreferrer" target="_blank" class="btn btn-outline-info btn-sm equal-width-btn me-2 ms-2">
            <i class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz pustą
          </a>
        </div>
        <div class="table-responsive w-100 mb-3">
          <table class="table table-bordered table-hover text-center">
            <thead>
              <tr>
                <th class="bg-gray-100"></th>
                <th class="bg-gray-100" v-for="day in 31" :key="'H2-head-' + day">{{ day }}</th>
                <th class="bg-gray-100">R</th>
                <th class="bg-gray-100">N</th>
                <th class="bg-gray-100">GN</th>
                <th class="bg-gray-100">DW</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="month in [7, 8, 9, 10, 11, 12]" :key="'H2-' + month">
                <tr>
                  <td class="bg-gray-100 text-start"><strong>{{ monthName(month) }}</strong></td>
                  <td v-for="day in 31" :key="'H2-hours-row-' + month + '-' + day" :class="[
                    'p-1',
                    day > getDaysInMonth(month).length
                      ? 'bg-white text-dark'
                      : (isHoliday(getDateString(day, month)) || isWeekend(month, day))
                        ? 'bg-Lightblue text-white'
                        : 'bg-white'
                  ]">
                    <span v-if="day > getDaysInMonth(month).length" class="fw-bold">X</span>
                    <span v-else-if="!shouldRenderCell(this.selectedYear, month, day)"></span>
                    <span v-else>
                      <span v-if="isHoliday(getDateString(day, month)) || isWeekend(month, day)"></span>
                      <span v-else :class="getCellClass(day, month, 'days')">
                        {{ getCellValue(day, month, 'days') }}
                      </span>
                    </span>
                  </td>

                  <td class="bg-gray-100"><strong>{{ getWorkingHours(month) }}</strong></td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                </tr>

                <tr>
                  <td class="bg-gray-100 text-start"><strong>godz.</strong></td>

                  <td v-for="day in 31" :key="'H2-hours-row-' + month + '-' + day" :class="[
                    'p-1',
                    day > getDaysInMonth(month).length
                      ? 'bg-white text-dark'
                      : (isHoliday(getDateString(day, month)) || isWeekend(month, day))
                        ? 'bg-Lightblue text-white' 
                        : 'bg-white'
                  ]">
                    <span v-if="day > getDaysInMonth(month).length" class="fw-bold">X</span>
                    <span v-else-if="!shouldRenderCell(this.selectedYear, month, day)"></span>
                    <span v-else>
                      <span v-if="isHoliday(getDateString(day, month)) || isWeekend(month, day)"></span>
                      <span v-else :class="getCellClass(day, month, 'hours')">
                        {{ getCellValue(day, month, 'hours') }}
                      </span>
                    </span>

                  </td>

                  <td class="bg-gray-100"><span v-if="CzyPodsumowanie(this.selectedYear, month)"><strong>{{
                        getTotalHoursForMonth(month) }}</strong></span></td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                  <td class="bg-gray-50">0</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>


    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from 'axios';

export default {
  props: {
    userId: Number,
    userName: String,
    userGodziny: String,
    isInwalida: Number,
    liczba_bazowa: Number,
    liczba_godzin: Number,

  },
  components: { AppLayout },

  data() {
    const today = new Date();
    return {
      Godziny: {},
      currentYear: today.getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      selectedYear: today.getFullYear(),
      months: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
      years: Array.from({ length: 11 }, (_, i) => new Date().getFullYear() - 10 + i),
      localUser: {
        id: this.userId,
        name: this.userName,
        godziny: this.userGodziny,
        absences: {}
      },
      wykorzystaneDniWolne: 0,
      typyUrlopow: [],
    };
  },
  watch: {

    selectedYear() {
      this.loadData();
      this.loadGodziny();

    }
  },
  methods: {
    shouldRenderCell(year, month, day) {
      const today = new Date();
      const date = new Date(year, month - 1, day);
      if (year < today.getFullYear()) return true;
      if (year === today.getFullYear() && month < today.getMonth() + 1) return true;
      if (year > today.getFullYear()) return false;
      if (year === today.getFullYear() && month > today.getMonth() + 1) return false;
      return date <= today;
    },

    CzyPodsumowanie(year, month) {
      const today = new Date();
      if (year < today.getFullYear()) return true;
      if (year === today.getFullYear() && month < today.getMonth() + 1) return true;
      if (year > today.getFullYear()) return false;
      if (year === today.getFullYear() && month > today.getMonth() + 1) return false;
      return true;
    },

    getCellClass(day, month, rowType) {
      const key = this.getDateString(day, month);
      const absence = this.localUser.absences[key];

      if (!absence) return 'text-black';

      const typeObj = this.typyUrlopow.find(t => t.id === absence.raw);
      const skrot = typeObj?.skrot ?? '';

      if (skrot.includes('Ch') || skrot.includes('Śrh') || skrot.includes('Nn') || skrot === 'N' || skrot === 'L4') return 'text-red';
      if (skrot === 'D' || skrot === 'S' || skrot === 'HO') return 'text-black';
      if (skrot === 'K' || skrot === 'Sz' || skrot === 'Np' || skrot === 'Wpp' || skrot === 'Us') return 'text-blue';
      return 'text-green';
    },

    getTotalHoursForMonth(month) {
      const days = this.getDaysInMonth(month);
      let total = 0;

      days.forEach(day => {
        const key = this.getDateString(day, month);
        if (this.localUser.umowa_do && new Date(key) > new Date(this.localUser.umowa_do)) return;
        const absence = this.localUser.absences[key];
        if (this.isWeekend(month, day) || this.isHoliday(key)) return;
        let hours = 0;
        if (absence) {
          const typeObj = this.typyUrlopow.find(t => t.id === absence.raw);
          const skrot = typeObj?.skrot ?? '';
          if (skrot.includes('Ch') || skrot.includes('Śrh') || skrot.includes('Nn') || skrot === 'N' || skrot.includes('L4') || skrot === 'Ub') {
            hours = 0;
          } else {
            hours = this.liczba_godzin;
          }
        } else if (this.Godziny && this.Godziny[key]) {
          const [start, end] = this.Godziny[key].split('-').map(s => parseFloat(s.split(':')[0]));
          hours = end - start || this.liczba_godzin;
        } else {
          hours = 0;
        }

        total += hours;
      });

      return total;
    },


    getWorkingHours(month) {
      const days = this.getDaysInMonth(month);
      let total = 0;
      days.forEach(day => {
        const key = this.getDateString(day, month);
        if (this.isWeekend(month, day) || this.isHoliday(key)) return;
        total += this.liczba_godzin;
      });

      return total;
    },

    getDaysInMonth(month) {
      return new Array(new Date(this.selectedYear, month, 0).getDate()).fill(0).map((_, i) => i + 1);
    },

    monthName(month) {
      return this.months[month - 1];
    },

    isWeekend(month, day) {
      const date = new Date(this.selectedYear, month - 1, day);
      return date.getDay() === 0 || date.getDay() === 6;
    },

    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year / 100);
      const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
      const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
      const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
      const L = I - J;
      const month = 3 + f((L + 40) / 44);
      const day = L + 28 - 31 * f(month / 4);
      return new Date(year, month - 1, day);
    },

    getPolishHolidays(year) {
      const formatDate = (date) => {
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      };

      const fixedHolidays = [
        `${year}-01-01`,
        `${year}-01-06`,
        `${year}-05-01`,
        `${year}-05-03`,
        `${year}-08-15`,
        `${year}-11-01`,
        `${year}-11-11`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
      ];

      const easter = this.getEasterDate(year);
      const holidays = [...fixedHolidays];
      holidays.push(formatDate(easter));
      holidays.push(formatDate(new Date(easter.getTime() + 86400000)));
      holidays.push(formatDate(new Date(easter.getTime() + 60 * 86400000)));

      return holidays;
    },

    isHoliday(dateInput) {
      if (!dateInput) return false;
      const dateStr = typeof dateInput === 'string' ? dateInput : this.formatDate(dateInput);
      const year = parseInt(dateStr.substring(0, 4));
      const holidays = this.getPolishHolidays(year);
      return holidays.includes(dateStr);
    },

    formatDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },

    getDateString(day, month) {
      return `${this.selectedYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    },


    async loadData() {
      try {
        const response = await axios.get(route('kadry.karta_ewidencji.kartagetinfo'), {
          params: { rok: this.selectedYear, user_id: this.localUser.id }
        });

        const absences = {};
        const urlopy = Array.isArray(response.data.urlopy) ? response.data.urlopy : [];

        urlopy.forEach(wniosek => {
          let start = new Date(wniosek.start);
          let end = new Date(wniosek.end);
          while (start <= end) {
            const key = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;
            absences[key] = {
              type: wniosek.type,
              raw: wniosek.raw_typ_urlopu,
              approved: wniosek.status === 1
            };
            start.setDate(start.getDate() + 1);
          }
        });

        this.localUser.absences = absences;
        this.wykorzystaneDniWolne = response.data.wykorzystaneWolne ?? 0;
        this.typyUrlopow = Array.isArray(response.data.typyUrlopow) ? response.data.typyUrlopow : [];
        this.localUser.godziny = response.data.userGodziny ?? this.localUser.godziny;

      } catch (error) {
        console.error("Błąd pobierania danych:", error);
      }
    },
    async loadGodziny() {
      try {
        const response = await axios.get(route('kadry.karta_ewidencji.workHours', { userId: this.localUser.id }), {
          params: {
            rok: this.selectedYear,
            user_id: this.localUser.id
          }
        });

        this.Godziny = response.data.Godziny || {};
        console.log('Godziny:', this.Godziny);

      } catch (error) {
        console.error("Błąd pobierania danych:", error);
      }
    },

    getCellValue(day, month, rowType) {
      const key = this.getDateString(day, month);

      if (this.localUser.umowa_do && new Date(key) > new Date(this.localUser.umowa_do)) {
        return '';
      }


      const absence = this.localUser.absences[key];

      if (this.isWeekend(month, day)) return '';
      let skrot = '';
      if (absence) {
        const typeObj = this.typyUrlopow.find(t => t.id === absence.raw);
        skrot = typeObj?.skrot ?? '';
      }

      const standardHours = this.liczba_godzin;

      const changeGodziny = (hours) => {
        if (!hours || typeof hours !== 'string' || !hours.includes('-')) return hours;

        const [startStr] = hours.split('-');
        const [h, m = 0] = startStr.split(':').map(Number);

        const startFloat = h + m / 60;
        const endFloat = startFloat + this.liczba_godzin;

        const startHour = Math.floor(startFloat);
        const startMinutes = Math.round((startFloat - startHour) * 60);

        const endHour = Math.floor(endFloat);
        const endMinutes = Math.round((endFloat - endHour) * 60);

        const formatTime = (hour, minutes) => minutes === 0 ? `${hour}` : `${hour}:${minutes.toString().padStart(2, '0')}`;

        return `${formatTime(startHour, startMinutes)}-${formatTime(endHour, endMinutes)}`;
      };

      if (rowType === 'hours') {
        if (this.localUser.umowa_do && new Date(key) > new Date(this.localUser.umowa_do)) {
          return '';
        }

        if (skrot && !['HO'].includes(skrot)) {
          if (['Śrh', 'Ch', 'ChO', 'Nn', 'N', 'L4', 'Ub'].includes(skrot)) return -standardHours;
          if (['Uw', 'Np', 'Wpp', 'Uo', 'UWW', 'Uż'].includes(skrot)) return standardHours;
          return standardHours;
        }
       if (this.Godziny && this.Godziny[key]) {
          return changeGodziny(this.Godziny[key]);
        }
       return '';
      } else { 
        if (skrot) return skrot;
        //  if (this.Godziny && this.Godziny[key]) return this.Godziny[key].split('-')[0]; 
        // return changeGodziny(this.localUser.godziny);
        return this.liczba_godzin;

      }
    },

    isToday(day, month) {
      const today = new Date();
      return day === today.getDate() && month - 1 === today.getMonth() && this.selectedYear === today.getFullYear();
    },

    isSunday(day, month) {
      return new Date(this.selectedYear, month - 1, day).getDay() === 0;
    },

    isSaturday(day, month) {
      return new Date(this.selectedYear, month - 1, day).getDay() === 6;
    }
  },

  mounted() {
    this.loadData();
    this.loadGodziny();
  }
};
</script>

<style scoped>
table th,
table td {
  min-width: 32px;
  height: 32px;
  text-align: center;
}

.bg-Lightblue {
  background-color: #5fb2d8;
}

.bg-gray-100 {
  background-color: #c4bc96;
  color: black;
}

.bg-gray-50 {
  background-color: #ddd9c3;
  color: black;
}

.text-white {
  color: white;
}

.text-black {
  color: black;
}

.text-red {
  color: red;
}

.text-green {
  color: green;
}

.text-blue {
  color: blue;
}
</style>
